export default "__VITE_ASSET__CF6WjZiw__"